// ============需要登录不受权限控制的的菜单============

import paymentLink from '../modules/paymentLink'
const main = (resolve) => require(['@/views/index/index.vue'], resolve) // 主页
const addWebsite = (resolve) =>
  require(['@/views/websiteCenter/websiteManage/addWebsite/index.vue'], resolve) //  添加网站

// 商户操作指南
const operationGuide = (resolve) =>
  require(['@/views/homePage/operationGuide.vue'], resolve) //  添加网站
  // const Settlement = (resolve) =>
//   require(['@/views/settlement/settlement.vue'], resolve) // 打款记录

const ChargebackDetail = (resolve) =>
  require(['@/views/riskManagement/chargeback/chargebackDetail.vue'], resolve) // 拒付
const dataReport = (resolve) =>
  require(['@/views/transactionAnalysis/index.vue'], resolve) // 交易分析

const createPaymentLink = (resolve) =>
  require(['@/views/paymentLink/paymentLink/createPaymentLink'], resolve) //  创建支付链

const createPaymentLinkV3 = (resolve) =>
  require(['@/views/paymentLink/paymentLink/createPaymentLinkV3'], resolve) //  创建支付链

const paymentLinkDetail = (resolve) =>
  require(['@/views/paymentLink/paymentLink/detail'], resolve) //  支付链详情

const paymentLinkV2Detail = (resolve) =>
  require(['@/views/paymentLink/paymentLink/detailV2'], resolve) //  支付链详情V2
  
const paymentLinkV3Detail = (resolve) =>
  require(['@/views/paymentLink/paymentLink/detailV3'], resolve) //  支付链详情V3
  
const addBrand = (resolve) =>
  require(['@/views/paymentLink/brandInfo/addBrand'], resolve) //  添加品牌信息

const addTemplate = (resolve) =>
  require(['@/views/paymentLink/templateManage/addTemplate'], resolve) //  添加支付链模版

const addMode = (resolve) =>
  require(['@/views/paymentLink/modeManage/addMode'], resolve) // 添加支付链模式

const addTheme = (resolve) =>
  require(['@/views/paymentLink/themeManage/addTheme'], resolve) // 添加支付链主题

const emailPreview = (resolve) =>
  require(['@/views/paymentLink/brandInfo/emailPreview'], resolve) // 邮件模版预览

const operatorDetail = (resolve) =>
  require(['@/views/system/operatorDetail.vue'], resolve) // operator 详情页
const modifyOperator = (resolve) =>
  require(['@/views/system/modifyOperator.vue'], resolve) // 新增修改页
const roleDetail = (resolve) =>
  require(['@/views/system/roleDetail.vue'], resolve) // 创建页
const modifyRole = (resolve) =>
  require(['@/views/system/modifyRole.vue'], resolve) // 创建页

const groupDetail = (resolve) =>
  require(['@/views/websiteCenter/groupManage/groupDetail.vue'], resolve) //  组详情
const websiteDetail = (resolve) =>
  require(['@/views/websiteCenter/websiteManage/websiteDetail'], resolve) // 网站详情
const websiteTradeDetail = (resolve) =>
  require(['@/views/websiteCenter/websiteManage/websiteTradeDetail'], resolve) // 网站交易明细

const accountCenter = (resolve) =>
  require(['@/views/accountCenter/index.vue'], resolve) // 账户中心

const Receiver = (resolve) =>
  require(['@/views/messageReceiverSetting/receiver.vue'], resolve) // 添加消息接收者

const password = (resolve) =>
  require(['@/views/accountCenter/changePassword.vue'], resolve) // 修改登陆密码

const changePhone = (resolve) =>
  require(['@/views/accountCenter/changePhone.vue'], resolve) // 修改绑定手机

const changeEmail = (resolve) =>
  require(['@/views/accountCenter/changeEmail.vue'], resolve) // 修改绑定邮箱

const clientWithdraw = (resolve) =>
  require(['@/views/withdrawModule/clientWithdraw.vue'], resolve) // 统一提现

const WthdrawOperationManual = (resolve) =>
  require(['@/components/WthdrawOperationManual/index.vue'], resolve) //  提现操作指南

export default [
  {
    path: '/index',
    component: main,
    children: [
      {
        name: 'AddWebsite',
        path: '/aq/addWebsite',
        alias: ['/aq/addWebsite.htm'],
        component: addWebsite
      },
      {
        name: 'OperationGuide',
        path: '/aq/operationGuide',
        alias: ['/aq/operationGuide.htm'],
        component: operationGuide
      },
      {
        name: 'ChargebackDetail',
        path: '/aq/chargebackDetail',
        alias: ['/aq/chargebackDetail.htm'],
        component: ChargebackDetail
      },
      // {
      //   name: 'settlement',
      //   path: '/aq/settlement',
      //   alias: ['/aq/settlement.htm'],
      //   component: Settlement,
      // },
      // 打款记录
      {
        name: 'DataReport',
        path: '/aq/dataReport',
        alias: ['/aq/dataReport.htm'],
        component: dataReport
      },
      // 群组详情
      {
        name: 'GroupDetail',
        path: '/aq/groupDetail',
        alias: ['/aq/groupDetail.htm'],
        component: groupDetail
      },

      // 创建支付链
      {
        name: 'CreatePaymentLink',
        path: '/aq/createPaymentLink',
        alias: ['/aq/createPaymentLink.htm'],
        component: createPaymentLink
      },
      // 创建支付链
      {
        name: 'CreatePaymentLinkV3',
        path: '/aq/createPaymentLinkV3',
        alias: ['/aq/createPaymentLinkV3.htm'],
        component: createPaymentLinkV3
      },
      // 支付链详情
      {
        name: 'PaymentLinkDetail',
        path: '/aq/paymentLinkDetail',
        alias: ['/aq/paymentLinkDetail.htm'],
        component: paymentLinkDetail
      },
      // 支付链详情V2
      {
        name: 'PaymentLinkDetail',
        path: '/aq/paymentLinkV2Detail',
        alias: ['/aq/paymentLinkV2Detail.htm'],
        component: paymentLinkV2Detail
      },
      // 支付链详情V3
      {
        name: 'PaymentLinkDetail',
        path: '/aq/paymentLinkV3Detail',
        alias: ['/aq/paymentLinkV3Detail.htm'],
        component: paymentLinkV3Detail
      },
      // 添加品牌信息
      {
        name: 'AddBrand',
        path: '/aq/addBrand',
        alias: ['/aq/addBrand.htm'],
        component: addBrand
      },
      {
        name: 'AddTemplate',
        path: '/aq/addTemplate',
        alias: ['/aq/addTemplate.htm'],
        component: addTemplate
      },
      {
        name: 'AddMode',
        path: '/aq/addMode',
        alias: ['/aq/addMode.htm'],
        component: addMode
      },
      {
        name: 'AddTheme',
        path: '/aq/addTheme',
        alias: ['/aq/addTheme.htm'],
        component: addTheme
      },

      
      // 邮件模版预览
      {
        name: 'EmailPreview',
        path: '/aq/emailPreview',
        alias: ['/aq/emailPreview.htm'],
        component: emailPreview
      },
      {
        path: '/aq/system/operator/:code',
        name: 'OperatorDetail',
        component: operatorDetail
      },
      {
        path: '/aq/system/operator/modify/:code',
        name: 'ModifyOperator',
        component: modifyOperator
      },
      {
        /**
         * 角色详情页
         */
        path: '/aq/system/role/:code',
        name: 'RoleDetail',
        component: roleDetail
      },
      {
        path: '/aq/system/role/modify/:code',
        name: 'RoleModify',
        component: modifyRole
      },
      // 网站详情
      {
        name: 'WebDetail',
        path: '/aq/webDetail',
        alias: ['/aq/webDetail.htm'],
        component: websiteDetail,
        meta: {
          keepAlive: true // 需要缓存
        }
      },
      // 交易详情
      {
        name: 'TradeDetail',
        path: '/aq/tradeDetail',
        alias: ['/aq/tradeDetail.htm'],
        component: websiteTradeDetail
      },
      // 账号中心
      {
        name: 'AccountCenter',
        path: '/aq/accountCenter',
        alias: ['/aq/accountCenter.htm'],
        component: accountCenter
      },
      // 新增、修改接受人
      {
        name: 'Receiver',
        path: '/aq/receiver',
        alias: ['/aq/receiver.htm'],
        component: Receiver
      },
      // 修改登陆密码
      {
        name: 'Password',
        path: '/aq/password',
        alias: ['/aq/password.htm'],
        component: password
      },
      // 修改注册手机
      {
        name: 'ChangePhone',
        path: '/aq/changePhone',
        alias: ['/aq/changePhone.htm'],
        component: changePhone
      },
      // 修改绑定邮箱
      {
        name: 'ChangeEmail',
        path: '/aq/changeEmail',
        alias: ['/aq/changeEmail.htm'],
        component: changeEmail
      },
      // 统一提现
      {
        name: 'ClientWithdraw',
        path: '/aq/clientWithdraw',
        alias: ['/aq/clientWithdraw.htm'],
        component: clientWithdraw
      },
      // 提现操作指南
      {
        name: 'WithdrawOperationManual',
        path: '/aq/WthdrawOperationManual',
        alias: ['/aq/WthdrawOperationManual.htm'],
        component: WthdrawOperationManual
      }
    ]
  },
  ...paymentLink
]
